import table from '../data/price-table.json' with { type: 'json' }

// Estimated BrickLink prices in USD, keyed `<ldraw part>/<ldraw colour>`.
// The table is checked in and filled by hand from public price guides (see
// its `source` and `date`); nothing here calls BrickLink at runtime. A live
// price-guide client can replace `unitPrice` later without touching callers.

interface PriceTable {
  date: string
  source: string
  currency: string
  prices: Record<string, number>
  // Fallback per part when a colour isn't in the table, from the common
  // colours' median.
  parts: Record<string, number>
}

const data = table as PriceTable

export const PRICE_DATE = data.date
export const PRICE_SOURCE = data.source

// Unknown part/colour combos are treated as expensive so the optimiser
// steers away from them rather than silently assuming they're cheap.
const UNKNOWN = 0.5

export function unitPrice(part: string, color: number): number {
  return data.prices[`${part}/${color}`] ?? data.parts[part] ?? UNKNOWN
}

export function hasPrice(part: string, color: number) {
  return `${part}/${color}` in data.prices
}
